import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Search, ImagePlus } from "lucide-react";
import { ImagePickerDialog } from "@/components/live/ImagePickerDialog";
import { resolveUrl } from "@/lib/content";
import { SITE_URL } from "@/lib/seo";

const Counter = ({ value, max }) => (
  <span className={`font-body text-xs ${value.length > max ? "text-lipstick-red" : "text-taupe"}`}>{value.length}/{max}</span>
);

export const BlogSeoFields = ({ formData, setFormData }) => {
  const [picker, setPicker] = useState(false);
  const title = formData.seo_title || (formData.title ? `${formData.title} — Kalani Luana` : "");
  const description = formData.seo_description || formData.excerpt;
  const image = formData.seo_image || formData.featured_image;

  return (
    <div className="rounded-xl border border-sand bg-sand/10 p-5 space-y-4" data-testid="blog-seo-fields">
      <h4 className="font-heading text-base text-charcoal flex items-center gap-2"><Search className="w-4 h-4 text-jade-text" /> Search & social settings <span className="font-body text-xs text-taupe">(optional — defaults to title, excerpt and featured image)</span></h4>
      <div>
        <div className="flex justify-between mb-1"><Label className="font-body text-sm text-stone-grey">Search title</Label><Counter value={formData.seo_title || ""} max={60} /></div>
        <Input data-testid="blog-seo-title" value={formData.seo_title || ""} onChange={(e) => setFormData({ ...formData, seo_title: e.target.value })} placeholder={title || "Custom title for Google"} className="form-input" />
      </div>
      <div>
        <div className="flex justify-between mb-1"><Label className="font-body text-sm text-stone-grey">Search description</Label><Counter value={formData.seo_description || ""} max={160} /></div>
        <Textarea data-testid="blog-seo-description" rows={2} value={formData.seo_description || ""} onChange={(e) => setFormData({ ...formData, seo_description: e.target.value })} placeholder={description || "Custom description for Google and social previews"} className="form-input" />
      </div>
      <div>
        <Label className="font-body text-sm text-stone-grey mb-1 block">Share image</Label>
        <div className="flex items-center gap-3">
          {image ? <img src={resolveUrl(image)} alt="" className="w-20 h-12 rounded object-cover bg-sand/30" data-testid="blog-seo-image-preview" /> : <div className="w-20 h-12 rounded bg-sand/30" />}
          <Button type="button" variant="outline" size="sm" onClick={() => setPicker(true)} data-testid="blog-seo-pick-image"><ImagePlus className="w-4 h-4 mr-1" /> Choose</Button>
          {formData.seo_image && <Button type="button" variant="ghost" size="sm" onClick={() => setFormData({ ...formData, seo_image: "" })} data-testid="blog-seo-clear-image">Use featured image</Button>}
        </div>
      </div>
      <div className="rounded-lg border border-sand bg-white p-4" data-testid="blog-seo-preview">
        <p className="font-body text-xs text-jade-text truncate">{SITE_URL}/blog/{formData.slug || "your-post"}</p>
        <p className="font-body text-base text-[#1a0dab] leading-snug truncate">{title || "Post title — Kalani Luana"}</p>
        <p className="font-body text-sm text-stone-grey leading-snug line-clamp-2">{description || "Post excerpt appears here."}</p>
      </div>
      <ImagePickerDialog open={picker} onClose={() => setPicker(false)} onSelect={({ url }) => setFormData({ ...formData, seo_image: url })} title="Choose share image" />
    </div>
  );
};
